module.exports = __webpack_public_path__ + "img/role_joy.2873985f.png";